'use client';

import React, { Suspense, useEffect } from 'react';
import {
  ProductSpecificationPage,
  ProductSpecificationSkeleton,
} from '@/components/product/ProductSpecification';
import { useProducts } from '@/stores/product';
import { useStore } from 'zustand';
import { useMapStore } from '@/stores/map/mapStore';
import ModalMap from '@/components/map/component/modal-map';
import { MRCOOL } from '@/utils/constants';
import FormatValue from '@/utils/FormatValue';

interface Props {
  params: Promise<{
    slug: string;
  }>;
  searchParams: any;
}

export default function Page({ params }: Props) {
  const { modalMapOpen, setModalMapOpen } = useStore(useMapStore, (state) => ({
    modalMapOpen: state.modalMapOpen,
    setModalMapOpen: state.setModalMapOpen,
  }));
  const resolvedSlug = React.use(params).slug;
  const { product, getProduct } = useProducts();
  const slugTitle = FormatValue.capitalizeFirstLetterOfEachWord(
    resolvedSlug.replace('-', ' ')
  );

  useEffect(() => {
    getProduct({
      id: resolvedSlug,
    });
  }, [resolvedSlug, slugTitle, getProduct]);

  useEffect(() => {
    document.title = `${product?.attributes?.specs_meta_title ? `${product.attributes.specs_meta_title} | ${MRCOOL}` : MRCOOL}`;
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        'content',
        `${product?.attributes?.specs_meta_description ? `${product.attributes.specs_meta_description}` : 'Meta Description'}`
      );
    }
  }, [product]);
  return (
    <>
      <Suspense fallback={<ProductSpecificationSkeleton />}>
        <ProductSpecificationPage
          data={product}
          modelSeries={product?.attributes?.modelSeries}
        />
      </Suspense>
      <ModalMap mapOpen={modalMapOpen} setMapOpen={setModalMapOpen} />
    </>
  );
}
